<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">用户权限<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>用户状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>用户类型</label>
              <el-select v-model="loginState" placeholder="Select" class="select-item">
                <el-option v-for="item in loginStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <!--          <div class="content-input-item">-->
            <!--            <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>-->
            <!--          </div>-->

            <div class="content-input-item">
              <label>角色类型</label>
              <el-select v-model="positionType" placeholder="Select" class="select-item" @change="positionTypeChange">
                <el-option v-for="item in positionTypeArray" :key="item.positionType" :label="item.name" :value="item.positionType">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>角色名称</label>
              <el-select v-model="sysRoleId" placeholder="Select" class="select-item">
                <el-option v-for="item in sysRoleIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <!--              <label>用户搜索</label>-->
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
<!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div style="display: flex;">
            <el-button type="primary" @click="editUserDialog(-1)" size="default">创建用户</el-button>
            <el-upload
                action="—"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="upLoadText">
              <el-button v-loading="upTextLoading" type="warning" style="margin-left: 16px;">导入Excel</el-button>
            </el-upload>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
          >
<!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="account" label="账号" v-if="checkColList.indexOf('账号') > -1"/>
            <el-table-column property="phone" label="手机号" v-if="checkColList.indexOf('手机号') > -1"/>
            <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1"/>
            <el-table-column property="" label="角色类型" v-if="checkColList.indexOf('角色类型') > -1">
              <template #default="scope">
                {{scope.row.positionType == 1?'老板':scope.row.positionType == 2?'总部账号':scope.row.positionType == 3?'店长':scope.row.positionType == 4?'员工':''}}
              </template>
            </el-table-column>
            <el-table-column property="name" label="角色名称" v-if="checkColList.indexOf('角色名称') > -1">
              <template #default="scope">
                <p v-if="scope.row.sysRole">{{scope.row.sysRole.name}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1">
              <template #default="scope">
                <p v-if="scope.row.ownShopState > 0">全部</p>
                <div v-else>
                  <p v-for="(item,index) of scope.row.ownShopList" :key="item.id">{{item.name}}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="可编辑门店" v-if="checkColList.indexOf('可见门店') > -1">
              <template #default="scope">
                <p v-if="scope.row.ownShopState == 2">全部</p>
                <div v-else v-for="(item,index) of scope.row.ownShopList" :key="item.id">
                  <p v-if="item.isEdit == 1">{{item.name}}</p>
                </div>

              </template>
            </el-table-column>
<!--            <el-table-column property="" label="职位" v-if="checkColList.indexOf('职位') > -1">-->
<!--              <template #default="scope">-->
<!--                <span>{{ scope.row.position.name }} </span>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column property="" label="超级管理员" v-if="checkColList.indexOf('超级管理员') > -1">-->
<!--              <template #default="scope">-->
<!--                <p>{{scope.row.isSuper == 1?'是':'否'}}</p>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column property="" label="可见时间" v-if="checkColList.indexOf('可见时间') > -1">
              <template #default="scope">
                <p>{{scope.row.duration == 0?'不限':scope.row.duration + '个月'}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p>{{scope.row.state == 0?'正常':scope.row.state == 1?'已停用':'' }}<span v-if="scope.row.loginState == 1" style="color: red; font-size: 12px;">（不可登录）</span></p>

              </template>
            </el-table-column>
            <el-table-column property="dismissionDate" label="离职时间" v-if="checkColList.indexOf('离职时间') > -1"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="180">
              <template #default="scope">
                <el-space>
                  <el-link @click="editUserDialog(scope.$index,scope.row)" type="primary">编辑</el-link>
                  <el-link @click="editUserModelDialog(scope.row)" type="success">权限</el-link>
                  <el-link v-if="scope.row.state == 1" @click="updateState(scope.row, 0)" type="warning">启用</el-link>
                  <el-link v-if="scope.row.state == 0"  @click="updateState(scope.row, 1)" type="danger">停用</el-link>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <div style="display: flex; justify-content: flex-end; align-items: center">
            <el-button type="text" style="margin: 16px 16px 0 0;" @click="reFresh">刷新</el-button>
            <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {getFormData, imgPostFormData, postFormData} from "@/api/api";
import {
  getAllShopList,
  userListAll,
  listFilterSysRole,
  updateAdminState,
  delMenuList,
  uploadTextExcel
} from "@/api/url";
import SysAdminDialog from "./components/SysAdminDialog";
import UserModelDialog from "./components/UserModelDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";

export default {
  name: "SysAdmin",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
     return {
       pageDataList: [],
       currentPage: 1,
       totalRow: 0,
       pageSize: 20,
       listLoading: false,
       searchLoading: false,
       updateLoading: false,

       shopIdArray: [
         {name: '不限', id: -1},
       ],
       shopIdArr:[],
       shopId: -1,

       stateArray: [
         {label: '不限', value: -1},
         {label: '正常', value: 0},
         {label: '停用', value: 1}
       ],
       state: 0,

       loginStateArray: [
         {label: '不限', value: -1},
         {label: '可登录', value: 0},
         {label: '不可登录', value: 1}
       ],
       loginState: -1,

       sysRoleList: [],

       positionTypeArray: [
         {name: '不限', positionType: -1},
       ],
       positionType: -1,

       sysRoleIdArray: [
         {name: '不限', id: -1},
       ],
       sysRoleId: -1,

       //刷新组
       colList: ['创建时间', '账号', '手机号', '名称', '角色类型', '角色名称', '所属门店', '可见门店', '可见时间','状态', '离职时间', '操作'],
       checkColList: [],

       //搜索
       searchTypeList: [
         {label : '手机号', value : 1},
         {label : '账号', value : 2},
         {label : '名称', value : 3},
       ],
       searchType: 1,
       searchValue: '',

       upTextLoading: false,
       refreshState: false,

     }
  },
  methods: {

    reFresh() {
      this.$confirm('确定刷新页面吗？', {
        type: 'warning'
      }).then(
          () => {
            this.refreshState = true
            this.getPage()
          })
    },

    upLoadText(file) {
      // console.log(file)
      this.upTextLoading = true
      let param = new FormData();
      param.append('file', file.raw);
      imgPostFormData(uploadTextExcel, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          // this.getPage(true)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        this.upTextLoading = false
      }).catch(()=>{
        this.upTextLoading = false
      })
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['loginState'] = this.loginState;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['shopId'] = this.shopId;
      param['positionType'] = this.positionType;

      if(this.refreshState) {
        param['refreshState'] = 1;
      }

      // if(this.shopId == -1) {
      //   let shopIds = [0]
      //   this.shopIdArray.map(item => {
      //     if(item.id != -1) {
      //       shopIds.push(item.id)
      //     }
      //   })
      //   param['shopIds'] = shopIds.toString();
      // }else {
      //   param['shopIds'] = this.shopId;
      // }
      // if(this.positionType == -1) {
      //   let positionTypes = []
      //   this.positionTypeArray.map(item => {
      //     if(item.positionType != -1) {
      //       positionTypes.push(item.positionType)
      //     }
      //   })
      //   param['positionTypes'] = positionTypes.toString();
      // }else {
      //   param['positionTypes'] = this.positionType;
      // }
      if(this.sysRoleId == -1) {
        let sysRoleIds = []
        this.sysRoleIdArray.map(item => {
          if(item.id != -1) {
            sysRoleIds.push(item.id)
          }
        })
        param['sysRoleIds'] = sysRoleIds.length > 0?sysRoleIds.toString():0;
      }else {
        param['sysRoleIds'] = this.sysRoleId;
      }
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(userListAll, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
        this.refreshState = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
            this.refreshState = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editUserDialog(idx, row) {
      let idArr = this.shopIdArr.filter(item => item.id != 0)
      let _title = '';
      let userForm = {}
      if (idx > -1) {
        _title = '编辑用户'
        userForm = Object.assign({}, row);
        // console.log(userForm)
      }else {
        _title = '创建用户'
        // console.log(userForm)
      }
      Dialog.open({
        title: _title,
        component: SysAdminDialog,
        data: {
          userForm: userForm,
          shopIdArr: idArr,
          ids: idx,
          width: '700px',
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    editUserModelDialog(row) {
      let _title = row.account + ' 的权限'
      console.log(_title)
      let userModelForm = Object.assign({},row)
      Dialog.open({
        title: _title,
        component: UserModelDialog,
        data: {
          userModelForm: userModelForm,
          width: '700px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },
    //
    // getShopList() {
    //   getFormData(getAllShopList).then(data=> {
    //     data.data.map((item) => {
    //       this.shopIdArr.push(item)
    //     })
    //     this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
    //   })
    // },

    positionTypeChange() {
      this.sysRoleIdArray = [
        {name: '不限', id: -1}
      ]
      this.sysRoleId = -1
      if(this.positionType == -1) {
        this.positionTypeArray = [
          {name: '不限', positionType: -1},
        ]
        this.getSysRoleList()
      }else {
        for(let i=0; i<this.sysRoleList.length; i++) {
          if(this.positionType == this.sysRoleList[i].positionType) {
            this.sysRoleIdArray = this.sysRoleIdArray.concat(this.sysRoleList[i].sysRoleVOList)
          }
        }
      }

    },

    getSysRoleList() {
      getFormData(listFilterSysRole).then(data=> {
        if(data.code == 200) {
          this.sysRoleList = data.data
          this.sysRoleList.map(item => {
            let obj = {}
            obj.name = item.name
            obj.positionType = item.positionType
            this.positionTypeArray.push(obj)
            item.sysRoleVOList.map(s => {
              this.sysRoleIdArray.push(s)
            })
          })
        }
      })
    },

    updateState(row, state) {
      this.$confirm('确认'+(state == 0?'启用':'停用')+'【'+row.name+'】？', {
        type: 'warning'
      }).then(
          () => {
            let param = {}
            param['id'] = row.id
            param['state'] = state
            postFormData(updateAdminState, param).then(data => {
              let {msg, code } = data;
              if(code == 200) {
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
                row.state = state
              }else{
                this.$message({
                  showClose: true,
                  duration: 1000,
                  message: msg,
                  type: 'warning'
                })
              }
            })
          }
      ).catch(() => {})
    },


  },
  mounted() {
    this.getSysRoleList()
    this.shopIdArr = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(this.shopIdArr)
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    setTimeout(()=> {
      this.getPage();
    }, 500)

    // this.getShopList()
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
